import RegionService from '@/services/admin/region.service'
import TerritoryService from '@/services/admin/territory.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    //----------------------Region ----------------
    async getActiveRegionsSimpleData({commit}) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await RegionService.getActiveRegionsSimpleData();
            
            return response
        } catch (e) {
                // console.log(e)
                return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async getAllRegions({commit}) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await RegionService.getAllRegions();

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },
    async populateRegionEditModel({commit}, id) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await RegionService.populateRegionEditModel(id);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },
    async saveRegion({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await RegionService.saveRegion(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },
    //---------------------- End Region -----------------------------
    //----------------------Territory ----------------
    async getActiveTerritoriesSimpleData({commit}) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TerritoryService.getActiveTerritoriesSimpleData();
            
            
            return response
        } catch (e) {
                // console.log(e)
                return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async getAllTerritories({commit}) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TerritoryService.getAllTerritories();

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async populateTerritoryEditModel({commit}, id) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TerritoryService.populateTerritoryEditModel(id);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async saveTerritory({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TerritoryService.saveTerritory(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e.data.ExceptionMessage

        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async inactiveOrActiveTerritory({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await TerritoryService.inactiveOrActiveTerritory(payload)

            return response
        } catch (e) {
            // console.log('ex msg:')
            // console.log(e)
            return e.response.data

        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    //---------------------- End Territory -----------------------------

}

const mutations = {
}

export const adminMarket = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}